import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Loader = () => (
  <div style={{ 
    textAlign: 'center', 
    paddingTop: '50vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Loading...
  </div>
);

export function PrivateRoute({ children }) {
  const { accessToken, initialized } = useAuth();

  // Don't navigate until we know the auth state
  if (!initialized) {
    return <Loader />;
  }

  // If there's a valid token, allow access; otherwise redirect to login
  return accessToken ? children : <Navigate to="/login" replace />;
}

export function PublicRoute({ children }) {
  const { accessToken, initialized } = useAuth();

  // Wait for auth state to be determined
  if (!initialized) {
    return <Loader />;
  }

  // If user is authenticated, redirect to home; otherwise show public content
  return accessToken ? <Navigate to="/home" replace /> : children;
}
